import React from 'react';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Poll';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import pollStyles from './Poll.scss';
const VotableAnswers = ({ poll })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: pollStyles['answers']
    }, poll.answers.map(({ answerId, image, textContent })=>/*#__PURE__*/ React.createElement("li", {
            key: `answer:${answerId}`,
            className: pollStyles['answer']
        }, /*#__PURE__*/ React.createElement("div", {
            className: pollStyles['answer-row']
        }, image && /*#__PURE__*/ React.createElement(MinimalDumbo, {
            className: pollStyles['pollimage'],
            deviation: image,
            width: 72,
            height: 72
        }), /*#__PURE__*/ React.createElement(TextRenderer, {
            htmlExcerptLegacy: true,
            isPollWithHtmlExcerpt: true,
            className: classnames(pollStyles['answer-text'], 'da-editor-poll-thumb'),
            textContent: textContent,
            viewerKey: answerId,
            tipTapViewer: PollTiptapViewer,
            cookieType: MeasuredCookieType.EDITOR_POLL
        })))));
};
export default VotableAnswers;

//# sourceMappingURL=VotableAnswers.js.map